export default __webpack_public_path__ + "static/media/logo-loja.0f60172b.png";